import api from 'service/api'

const dponetAPI = api.create('supplierPortal')

const permissions = async () => {
  return await dponetAPI.get('/users/permissions')
}

const me = async () => {
  return await dponetAPI.get('/users/me')
}

export default {
  me,
  permissions,
}
